module.exports = __webpack_public_path__ + "static/media/Torres.38084faf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_logos/Torres.jpg
// module id = 665
// module chunks = 0